import { render, staticRenderFns } from "./AssignmentRuleSection.vue?vue&type=template&id=19ff448a&scoped=true&"
import script from "./AssignmentRuleSection.vue?vue&type=script&lang=js&"
export * from "./AssignmentRuleSection.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentRuleSection.vue?vue&type=style&index=0&id=19ff448a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ff448a",
  null
  
)

export default component.exports